import api from '@/configs/GlobalRequestHandler.js';

const PromoBannersHttp = {
  listActive: () => api.getRequest('/promo-banners'),
  listAdmin: () => api.getRequest('/admin/promo-banners'),
  create: (body) => api.postRequestWithBody('/admin/promo-banners', body),
  update: (id, body) => api.putRequestWithBody(`/admin/promo-banners/${id}`, body),
  remove: (id) => api.deleteRequest(`/admin/promo-banners/${id}`),
};

export default PromoBannersHttp;
